<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For my mother and Jay Patton, two people responsible for getting me started. Also, for George Willis, who kept me going when times and circumstances would have ended it all. The three of you have been there without request. You will never know how much it means to me. For my father, who passed on his love of Westerns to me.  Also, I dedicate this to my wife, Sue. Now you know what has been bouncing about in my head for the past several years.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?d2bdb45e